import {useSelector} from 'react-redux';
import Selector from '../../selectors/modals';
import Profile from './profile';
import Password from './password';
import Events from './events';
import Messages from './messages';
import Wheel from './wheel';
import Bonus from './bonus';
import Language from './language';

export default () => {
    const {isAuth} = useSelector(Selector);

    return (
        <div className="modal-overlay animate__fadeIn animate__animated" style={{display: 'none'}}>
            {isAuth && (
                <>
                    <Profile />
                    <Password />
                    <Events />
                    <Messages />
                    <Wheel />
                    <Bonus />
                </>
            )}
            
            <Language />
        </div>
    )
}